import { ElementType, useState } from 'react';
import Image from 'next/image';
import { motion } from 'motion/react';

type Props = {
  title: string;
  children: React.ReactNode;
  className?: string;
  btnClassName?: string;
  initialState?: boolean;
  titleAs?: ElementType;
};

const Expandable = ({
  title,
  children,
  className,
  initialState = true,
  btnClassName,
  titleAs,
}: Props) => {
  const [expanded, setExpanded] = useState(initialState);
  const Title = titleAs || 'h4';

  return (
    <div className={`overflow-hidden rounded-lg bg-white/10 ${className || ''}`}>
      <div className='flex items-center justify-between'>
        <button
          className={`flex w-full items-center justify-between ${btnClassName || 'bg-secondary/5 p-3 hover:bg-secondary/10'}`}
          onClick={() => setExpanded(!expanded)}
        >
          <Title className='font-bold'>{title}</Title>
          <Image
            src='/icons/common/arrow-white.svg'
            width={26}
            height={26}
            className={`transition ${expanded ? '-rotate-90' : 'rotate-90'}`}
            alt='Expand'
          />
        </button>
      </div>

      <motion.div
        className='overflow-hidden'
        initial={{ height: 'auto' }}
        animate={{ height: expanded ? 'auto' : 0 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default Expandable;
